import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
  Field,
  Input,
  makeStyles,
  Radio,
  RadioGroup,
  Spinner
} from "@fluentui/react-components";
import { useCommand } from "@tdp/core";
import React from "react";
import { useIntl } from "react-intl";
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
  container: {
    margin: "12px 0px 24px 0px",
    display: "flex",
    gap: "18px",
    flexDirection: "column",
  },
  errorBody: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
    overflowY: "auto"
  }
});

const ringItems = [
  {
    name: "Ring 0",
    key: "Ring 0",
    label: "Ring 0",
    value: "ring0"
  },
  {
    name: "Ring 1",
    key: "Ring 1",
    label: "Ring 1",
    value: "ring1"
  },
  {
    name: "Ring 1.5",
    key: "Ring 1.5",
    label: "Ring 1.5",
    value: "ring1_5"
  },
  {
    name: "Ring 1.6",
    key: "Ring 1.6",
    label: "Ring 1.6",
    value: "ring1_6"
  },
  {
    name: "Ring 2",
    key: "Ring 2",
    label: "Ring 2",
    value: "ring2"
  },
  {
    name: "Ring 3",
    key: "Ring 3",
    label: "Ring 3",
    value: "ring3"
  },
  {
    name: "Ring 3.6",
    key: "Ring 3.6",
    label: "Ring 3.6",
    value: "ring3_6"
  },
  {
    name: "Ring 3.9",
    key: "Ring 3.9",
    label: "Ring 3.9",
    value: "ring3_9"
  },
  {
    name: "Ring 4",
    key: "Ring 4",
    label: "Ring 4",
    value: "ring4"
  },
  {
    name: "GCC",
    key: "GCC",
    label: "GCC",
    value: "gcclow"
  },
  {
    name: "GCC high",
    key: "GCCH",
    label: "GCCH",
    value: "gcchigh"
  },
  {
    name: "DOD",
    key: "DOD",
    label: "DOD",
    value: "dod"
  },
  {
    name: "GCC internal",
    key: "GCC_internal",
    label: "GCC Low Internal",
    value: "gcc_flight"
  },
  {
    name: "GCC high internal",
    key: "GCCH_internal",
    label: "GCC High Internal",
    value: "gcchigh_flight"
  },
  {
    name: "DOD internal",
    key: "DOD_internal",
    label: "DOD Internal",
    value: "dod_flight"
  }
];

export const AppListFirstPartyImportCatalog: React.FC<{
  open: boolean;
  setOpen: (value: boolean) => void,
}> = ({ open, setOpen }) => {

  const navigate = useNavigate();
  const classes = useStyles();
  const intl = useIntl();

  const firstPartyImport = useCommand((commands) => commands.appListCommands.firstPartyImportCatalog);
  const [activeOption, setActiveOption] = React.useState("");
  const [isImporting, importing] = React.useState(false);
  const [appId, setAppId] = React.useState<string>('');

  const onCancel = () => {
    setOpen(false);
    importing(false);
  };

  const onClick = () => {
    importing(true);
    firstPartyImport({
      payload: {
        appId: appId,
        activeOptionText: activeOption
      },
      onCallback: () => { navigate(`/apps/${appId}/dashboard`); onCancel(); },
      onFailure: () => { onCancel(); }
    })
  }

  const isValidGUID = (guid: string) => /^[0-9a-f]{8}-[0-9a-f]{4}-4[0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(guid);

  return (
    <Dialog open={open}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{intl.formatMessage({ defaultMessage: "Take ownership" })}</DialogTitle>
          <DialogContent className={classes.container}>
            <Field label={intl.formatMessage({ defaultMessage: "App ID" })} required>
              <Input
                type="text"
                placeholder={'XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX'}
                disabled={isImporting}
                value={appId}
                onChange={(e) => setAppId(e.target.value)}
              />
            </Field>
            <Field label="Favorite Fruit">
              <RadioGroup value={activeOption} onChange={(_, data) => setActiveOption(data.value)}>
                {
                  ringItems.map((item) => {
                    return (
                      <Radio
                        key={item.key}
                        value={item.value}
                        label={item.label}
                      />
                    )
                  })
                }
              </RadioGroup>
            </Field>
          </DialogContent>
          <DialogActions>
            <Button appearance="secondary" onClick={() => { onCancel() }} disabled={isImporting}>
              {intl.formatMessage({ defaultMessage: "Cancel" })}
            </Button>
            <Button
              appearance="primary"
              icon={isImporting ? <Spinner size="tiny" /> : null}
              disabled={isImporting || !(isValidGUID(appId) && activeOption !== "")}
              onClick={onClick}
            >
              {intl.formatMessage({ defaultMessage: "Import" })}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}